import styled from "styled-components";

import { theme } from "../../theme";
const { margin, breakpoint } = theme;

export const Option = styled.div`
  white-space: pre-line;
  margin-bottom: ${margin.large / 2}px;
  @media ${breakpoint.medium} {
    margin-bottom: ${margin.medium / 2}px;
  }
  @media ${breakpoint.small} {
    margin-bottom: ${margin.medium / 2}px;
  }
`;
